<template>
    <div>
        <container :active_path="path" :plate="'投资军团'">
            <div class="base-warp">
                <div class="head">
                    <el-form :model="form" label-width="80px" :inline="true" size="mini">
                        <el-form-item label="姓名">
                            <el-input v-model="form.name" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="form.putaway" placeholder="请选择" clearable filterable>
                                <el-option v-for="(item, index) in putArr"
                                    :key="index"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="confirm" icon="el-icon-search">搜索</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="success" @click="add" icon="el-icon-plus">添加导师</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="$store.commit('settutorapplypicker', true)" icon="el-icon-s-custom">查看导师申请</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-box">
                    <el-table 
                    :data="tabledata" 
                    border 
                    size="mini"
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" width="60"></el-table-column>
                        <el-table-column prop="name" label="照片" align="center">
                            <template slot-scope="s">
                                <el-popover
                                    placement="top-start"
                                    width="200"
                                    trigger="hover">
                                    <el-image class="ltpic" :src="s.row.ltpic" fit="scale-down"></el-image>
                                    <el-avatar class="avatar" slot="reference" icon="el-icon-user-solid" size="large" shape="circle" :src="s.row.ltpic" fit="fill"></el-avatar>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="姓名"></el-table-column>
                        <el-table-column prop="serve" label="服务人数"></el-table-column>
                        <el-table-column prop="bargain" label="成交套数"></el-table-column>
                        <el-table-column prop="putaway" label="状态" align="center">
                            <template slot-scope="s">
                                <span class="text-success" v-if="s.row.putaway">上架</span>
                                <span class="text-danger" v-else>下架</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="putaway" label="推荐楼盘" align="center">
                            <template slot-scope="s">
                                <!-- <span class="btn-text link-text" @click="recommend(s.row)">查看楼盘</span> -->
                                <el-button type="info" size="mini" @click="recommend(s.row)" icon="el-icon-house">推荐楼盘</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column prop="putaway" label="过往案例" align="center">
                            <template slot-scope="s">
                                <!-- <span class="btn-text link-text" >查看案例</span> -->
                                <el-button type="info" size="mini" @click="anli(s.row)" icon="el-icon-s-order">过往案例</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="260">
                            <template slot-scope="s">
                                <el-button type="warning" v-if="s.row.putaway" size="mini" @click="putaway(s.row)" icon="el-icon-download">下架</el-button>
                                <el-button type="success" v-if="!s.row.putaway" size="mini" @click="putaway(s.row)" icon="el-icon-upload2">上架</el-button>
                                <el-button type="danger" size="mini" @click="del(s.row)" icon="el-icon-delete">删除</el-button>
                                <el-button type="primary" size="mini" @click="edit(s.row)" icon="el-icon-edit" plain>编辑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>
        </container>
        <tutor-apply-list></tutor-apply-list>
        <router-view></router-view>
    </div>
</template>

<script>
import Container from '../../../components/container.vue'
import TutorApplyList from '../../../components/invest/tutor/tutor-apply-list.vue';
export default {
    components: {
        Container,
        TutorApplyList,
    },
    data() {
        return {
            path: '/invest/tutor',
            form: {
                name: '',
                putaway: '',
            },
            putArr: ['显示', '不显示'],
            tabledata: [],
            pageNo: 1,
            pagesize: 8,
            total: 0,
        }
    },
    mounted () {
        this.getTabledata();
    },
    methods: {
        getTabledata() {
            var params = {
                name: this.form.name,
                putaway: this.form.putaway,
                pageNo: this.pageNo,
                pagesize: this.pagesize
            }
            this.$api.getTutorList(params).then(
                data=>{
                    let {list, total} = data;
                    this.tabledata = list;
                    this.total = total;
                }
            )
        },
        recommend(row) {
            var id = row._id['$oid']
            var name = row.name
            this.$router.push({path: '/invest/tutor/recommend', query:{id, name}})
        },
        anli(row) {
            var id = row._id['$oid']
            var name = row.name
            this.$router.push({path: '/invest/tutor/case', query:{id, name}})
        },
        add() {
            this.$router.push({path: '/invest/tutor/add'})
        },
        confirm() {
            this.pageNo = 1
            this.getTabledata();
        },
        currentChange(page) {
            this.pageNo = page;
            this.getTabledata();
        },
        edit(row) {
            var id = row._id['$oid'];
            this.$router.push({path: '/invest/tutor/edit', query:{id}})
        },
        putaway(row) {
            var id = row._id['$oid'];
            var params = {
                id,
                putaway: !row.putaway
            }
            this.$api.tutorPutaway(params).then(
                data=>{
                    this.$message.success(data);
                    this.getTabledata();
                }
            )
        },
        del(row) {
            this.$confirm('是否确定删除'+row.name).then(
                confirm=>{
                    var id = row._id['$oid'];
                    var params = {
                        id,
                    }
                    this.$api.delTutor(params).then(
                        data=>{
                            this.$message.success(data);
                            this.getTabledata();
                        }
                    )
                },
                cancel=>{}
            )
        },
    },
    beforeRouteUpdate(to, from, next) {
        if (from.path=="/invest/tutor/add"||from.path=="/invest/tutor/edit"||from.path=="/invest/tutor/case"){
            this.getTabledata();
        }
        next();
    },
}
</script>

<style lang="scss" scoped>
.ltpic{
    width: 200px;
    height: 200px;
}
</style>